module.exports = __webpack_public_path__ + "assets/img/busy_11.f8516f77.png";